import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type AggregationStatusType = {
  successCallback?: Function;
  errorCallback?: Function;
  resultKey: string;
};

export default ({ successCallback, errorCallback, resultKey = 'aggregationStatus' }: AggregationStatusType) =>
  requestAsync({
    url: endpoints.getAggregationStatusUrl(),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getAggregationStatusUrl(),
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
